import { DealersAndLocationsDropdownKeys } from "components/DealersAndLocationsDropdown/queryKeys";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { DealersDashboardQueryKeys } from "modules/DealersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DealerID, DealerLocation } from "models";

export type LocationFormPayload = Pick<
  DealerLocation,
  "name" | "active" | "commercial_name" | "headline" | "footerline" | "country" | "city" | "street" | "postal_code" | "phone_nr" | "language_code" | "logo"
>;

export type CreateLocationPayload = LocationFormPayload & {
  dealer_id: DealerID;
};

export const useCreateLocationMutation = () =>
  useTypedMutation<CreateLocationPayload, DealerLocation>({
    mutationFn: async payload => (await ApiInstance.post("/locations/create", payload, ENV.dealerBaseURL)).data,
    onSuccess: (_, createdLocation) => {
      const dealers = typedQueryClient.getQueryData(DealersDashboardQueryKeys.list);
      const listDealerIdx = dealers?.findIndex(dealer => dealer.id === createdLocation.dealer_id) ?? -1;

      if (dealers && listDealerIdx !== -1) {
        const listDealer = dealers[listDealerIdx];
        const listLocations = listDealer.locations ?? [];

        if (!listLocations.some(location => location.id === createdLocation.id))
          typedQueryClient.setQueryData(DealersDashboardQueryKeys.list, dealers.with(listDealerIdx, { ...listDealer, locations: [...listLocations, createdLocation] }));
      }

      const dealersList = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.dealers);
      const dealerIdx = dealersList?.dealers.findIndex(dealer => dealer.id === createdLocation.dealer_id) ?? -1;
      if (!dealersList || dealerIdx === -1) return;

      const dealer = dealersList.dealers[dealerIdx];
      const locations = dealer.locations ?? [];
      if (locations.some(location => location.id === createdLocation.id)) return;

      typedQueryClient.setQueryData(DealersAndLocationsDropdownKeys.dealers, {
        ...dealersList,
        dealers: dealersList.dealers.with(dealerIdx, { ...dealer, locations: [...locations, createdLocation] })
      });
    }
  });
